import { PRDService, InventoryService, ToastService } from '@/services'

const getDefaultState = () => {
    return {
        keyMaster: {},
        order: {},
        detail: [],
        assembly: [],
        newItem: null,
        orderPresentations: [],
        error: null,
        fetching: false,
        errorAnalysis: null,
        posting: false
    }
}

const state = getDefaultState()

const actions = {
    resetState({ commit }) {
        commit('resetState')
    },
    processOrder({state, commit}) {
        const id = state.order.id
        if (id && id == 0) return

        commit('setPosting', true)
        PRDService.processProductionOrder(id)
        .then(({ data, status }) => {
          if (data && data.errors) {
            commit("setErrorAnalysis", data.errors);
          } else {
            ToastService.success("La orden ha sido procesada exitosamente.")
            commit("resetState");
          }
        })
        .finally(() => commit('setPosting', false))

    },
    fetchOrder({ dispatch, commit }, prod_order_number) {
        if (prod_order_number === "") return

        commit('setFetching', true)
        commit('resetState')

        PRDService.getProductionWorkOrder(prod_order_number)
        .then(({ status, data }) => {
            if (status === 200) {
                commit('setOrder', data)
                dispatch('fetchOrderDetail')
                return PRDService.getKeyMaster(prod_order_number)
            }
        })
        .then(({ data }) => {
            if (data) {
                commit('setKeyMaster', data)
                return InventoryService.fetchProductPresentationList(data.product_name, data.product_brand)
            }
        }).then(({data}) => commit('setOrderPresentations', data))

        .finally(() => commit('setFetching', false))
    },
    fetchOrderDetail({ state, commit }) {
        PRDService.getProductionWorkOrderDetail(state.order.order_number)
        .then(({ status, data }) => {
            if (status === 200) {
                commit('setDetail', data)
            }
        })
    },
    insertOrderItem({ state, commit }, { presentation, quantity, machineQty, productEnv, productTap }) {
        return PRDService.postProductionWorkOrderDetail({ id: state.order.id, presentation, quantity, machineQty, productEnv, productTap })
        .then(({ status, data }) => {
            if (status === 201) {
                commit('addDetail', data)
                commit('clearNewItem')
            }
        })
    },
    updateOrderItem({ commit }, { id, newQuantity, newMachineQty}) {
        PRDService.putProductionWorkOrderDetail({ id, quantity: newQuantity, machineQty: newMachineQty })
        .then(({ status, data }) => {
            if (status === 200) {
                commit('updateDetail', data)
            }
        })
    },
    updateOrderAssembly({ commit }, { id, qtyType, quantity }) {
        PRDService.putProductionWorkOrderAssembly({ id, quantity, qtyType })
        .then(({ status, data }) => {
            if (status === 200) {
                commit('updateAssembly', data)
            }
        })
    },
    deleteOrderItem({ commit }, id) {
        PRDService.deleteProductionWorkOrderDetail(id)
        .then(({ status, data }) => {
            if (status === 200) {
                commit('removeDetail', data.id)
                commit('removeAssembly', data.seq_number)
            }
        })
    },
    getLineAssembly({ state, commit }, seq_number) {
        PRDService.getProductionWorkOrderLineAssembly(state.order.order_number, seq_number)
        .then(({ data }) => {
            commit('addAssembly', data)
        })
    },
    assignLotNumber({ state, commit }, data) {
        return PRDService.postAssignmentOrderAssemblyLot(data)
        .then(({ status }) => {
            console.log(status)
        })
    },
}

const mutations = {
    resetState: (state) => (Object.assign(state, getDefaultState())),
    setKeyMaster: (state, data) => (state.keyMaster = data),
    setOrderPresentations: (state, data) => (state.orderPresentations = data.map(e => e.model)),
    clearNewItem: (state) => (state.newItem = null),
    setFetching: (state, payload) => (state.fetching = payload),
    setOrder: (state, order) => (state.order = order),
    setDetail: (state, detail) => (state.detail = detail),
    addDetail: (state, item) => (state.detail.push(item)),
    updateDetail: (state, item) => {
        let index = state.detail.findIndex(el => el.id === item.id);
        if (index>=0) {
            state.detail[index].quantity = item.quantity
            state.detail[index].qtyMachine = item.qty_by_machine

        }
    },
    createNewItem: (state, payload) => {
        state.newItem = {
            product_base: state.order.product_base,
            quantity: 0,
            unitsPerMachine: 0,
            machineQty: 0,
            ...payload
        }
    },
    addAssembly: (state, payload) => {
        state.assembly.push(...payload)
    },
    updateAssembly: (state, payload) => {
        let index = state.assembly.findIndex(el => el.id === payload.id);
        if (index>=0) {
            state.assembly[index].qty_used = payload.qty_used
            state.assembly[index].qty_rejected = payload.qty_rejected
        }
    },
    removeDetail: (state, id) => (state.detail = state.detail.filter(el => el.id !== id)),
    removeAssembly: (state, seq_number) => (state.assembly = state.assembly.filter(el => el.seq_number !== seq_number)),
    setErrorAnalysis: (state, errorAnalysis) =>
    (state.errorAnalysis = errorAnalysis),
    setPosting: (state, payload) => (state.posting = payload)
}

const getters = {
    assemblyByLine: state => (seq_number) => {
        return state.assembly.filter(el => el.seq_number === seq_number)
    },
    totalXMachine: state => (unit_x_machine) => unit_x_machine * state.order.qty_machine
}

export const prdOrder = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/prd.order.module.js